module.exports = __webpack_public_path__ + "img/txt_disabled.3486a174.svg";